import { Injectable } from '@angular/core';
import { Observable ,  BehaviorSubject } from 'rxjs';
import { get, set, merge, indexOf, findIndex } from 'lodash';

const tree = {
  loading: false,
  test: {
    brands: []
  }
};

@Injectable()
export class TreeService {
  tree$;
  listeners = {};

  constructor() {
    this.tree$ = new BehaviorSubject(tree);
  }

  get(path = null) {
    if (path) {
      return get(tree, path);
    }
    return tree;
  }

  set(path = null, data) {
    set(tree, path, data);

    this.refresh(path);
  }

  listen(path = null) {
    if (path) {
      if (this.listeners[path]) {
        return this.listeners[path];
      } else {
        this.listeners[path] = new BehaviorSubject(get(tree, path));
        return this.listeners[path];
      }
    }
    return this.tree$;
  }

  refresh(path = null) {
    if (path && this.listeners[path]) {
      this.listeners[path].next(get(tree, path));
    }
    this.tree$.next(tree);
  }

  mutate(path, item, mode) {
    const array = get(tree, path);

    array[mode](item);

    this.refresh(path);
  }

  add(path, item) {
    this.mutate(path, item, 'push');
  }

  update(path, idOrIndex, data) {
    const array = get(tree, path);
    const index = this.find(path, { id: idOrIndex });
    const idx = index > -1 ? index : idOrIndex;

    array.splice(index, 1, data);

    this.refresh(path);
  }

  remove(path, itemToRemove) {
    const array = get(tree, path);
    const index = this.find(path, itemToRemove);

    array.splice(index, 1);

    this.refresh(path);
  }

  find(path, itemToFind) {
    const array = get(tree, path);
    const index = indexOf(array, itemToFind);
    const found = findIndex(array, { id: itemToFind.id });

    return index > -1 ? index : found;
  }
}
